import { BorderStyle, Direction, Displaying, Purplex, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const AiResponseFeedbackWrapper = styled(Box)({
  display: Displaying.flex,
  flexDirection: Direction.column,
  width: "100%",
  borderBottom: `1px ${BorderStyle.solid} ${Purplex[100]}`,
  paddingTop: Spacing[500],
  paddingBottom: Spacing[500],
  gap: Spacing[750],
});
